export default [{
  'id': 1,
  'py': 'ych',
  'name': '演唱会',
  'bid': 'b_3Rbqj'
}, {
  'id': 4,
  'py': 'hjgj',
  'name': '话剧歌剧',
  'bid': 'b_3Rbqj'
}, {
  'id': 9,
  'py': 'xxzl',
  'name': '休闲展览',
  'bid': 'b_3Rbqj'
}, {
  'id': 7,
  'py': 'qzyc',
  'name': '亲子演出',
  'bid': 'b_3Rbqj'
}, {
  'id': 2,
  'py': 'tyss',
  'name': '体育赛事',
  'bid': 'b_3Rbqj'
}, {
  'id': 6,
  'py': 'yyh',
  'name': '音乐会',
  'bid': 'b_3Rbqj'
}, {
  'id': 3,
  'py': 'xqys',
  'name': '戏曲艺术',
  'bid': 'b_3Rbqj'
}, {
  'id': 5,
  'py': 'wdbl',
  'name': '舞蹈芭蕾',
  'bid': 'b_3Rbqj'
}, {
  'py': 'yhzq',
  'name': '优惠专区',
  'bid': 'b_3Rbqj',
  'path': '/group-list'
}, {
  'id': 8,
  'py': 'gdjc',
  'name': '更多精彩',
  'bid': 'b_3Rbqj'
}];

// 需求文档：https://wiki.maoyan.com/pages/viewpage.action?pageId=235221821
export var categoryMapToPtChannelId = {
  1: '1737780072020525149',
  2: '1737780336408748042',
  3: '1737780694845472834',
  4: '1737780875020222560',
  5: '1737781067215773781',
  6: '1737781257670709249',
  7: '1737781456220565546',
  9: '1737781627650199648',
  10: '1737782061857288254',
  12: '1737782241666945035',
  14: '1737782391479066669',
  15: '1737782810401886289',
  16: '1737782963632533604'
};